module.exports = __webpack_public_path__ + "img/uimapaikka_original.4b92ae4b.jpg";